export default "__VITE_ASSET__BHW32_6g__"